import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
    const [contacts, setContacts] = useState([]);

    // Fetch contact data from the API
    useEffect(() => {
        axios.get("https://bigbucks.badskullgaming.com/api/get-contact")
            .then(response => {
                console.log("API response:", response.data); // Log response for debugging
                if (response.data && response.data.contact_us) {
                    setContacts(response.data.contact_us); // Access the nested array correctly
                } else {
                    setContacts([]); // Fallback to an empty array if data is not as expected
                }
            })
            .catch(error => {
                console.error("Error fetching contacts:", error);
                toast.error("Failed to fetch contacts.");
            });
    }, []);

    // Handle delete contact
    const handleDelete = (id) => {
        axios.delete(`https://bigbucks.badskullgaming.com/api/deletecontact/${id}`)
            .then(() => {
                setContacts(contacts.filter(contact => contact.id !== id));
                toast.success("Contact deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting contact:", error);
                toast.error("Failed to delete contact.");
            });
    };

    return (
        <>
            <div className="container">
                <h2>Contact Us Data</h2>
                {contacts.length > 0 ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Message</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contacts.map((contact, index) => (
                                <tr key={contact.id}>
                                    <td>{index + 1}</td>
                                    <td>{contact.name}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.message}</td>
                                    <td>
                                        <Button variant="danger" onClick={() => handleDelete(contact.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No contact data available.</p>
                )}
            </div>

            {/* Toast container */}
            <ToastContainer />
        </>
    );
};

export default ContactUs;
